"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { NAV_ITEMS } from "@/constants";
export default function MobileNav() {
  const $ = _c(19);
  const [open, setOpen] = useState(false);
  const pathname = usePathname() || "/";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setOpen(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== pathname) {
    t1 = [pathname];
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== open) {
    t2 = () => {
      const html = document.documentElement;
      html.style.overflow = open ? "hidden" : "";
      return () => {
        html.style.overflow = "";
      };
    };
    t3 = [open];
    $[3] = open;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== open) {
    t4 = () => {
      if (!open) {
        return;
      }
      const onKey = e => {
        if (e.key === "Escape") {
          setOpen(false);
        }
      };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    };
    t5 = [open];
    $[6] = open;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(true);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Menu size={20} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== open) {
    t8 = <button type="button" onClick={t6} aria-label="Open menu" aria-expanded={open} className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[var(--stroke)] text-[var(--text)] transition hover:border-[var(--accent)] hover:text-[var(--accent)]">{t7}</button>;
    $[11] = open;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== open || $[14] !== pathname) {
    t9 = open && <div role="dialog" aria-modal="true" aria-label="Mobile navigation" className="fixed inset-0 z-[80] md:hidden"><div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_10%,rgba(11,201,240,0.22),transparent_35%),radial-gradient(circle_at_85%_15%,rgba(1,123,252,0.2),transparent_40%),linear-gradient(180deg,#010133_0%,#020c52_55%,#010b3c_100%)]" aria-hidden="true" /><div className="relative z-10 flex h-full flex-col overflow-y-auto text-[var(--text)]"><div className="sticky top-0 flex items-center justify-between border-b border-[var(--stroke)] bg-[var(--bg)]/95 px-4 py-2 sm:px-6 backdrop-blur"><Link href="/" onClick={() => setOpen(false)} className="flex items-center" aria-label="Cybitix home"><Image src="/images/cybitix-solution-logo.png" alt="Cybitix" width={95} height={95} priority={true} className="h-12 w-auto sm:h-14" /></Link><button type="button" onClick={() => setOpen(false)} aria-label="Close menu" className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[var(--stroke)] text-[var(--text)] transition hover:border-[var(--accent)] hover:text-[var(--accent)]"><X size={20} /></button></div><nav aria-label="Primary" className="flex flex-1 flex-col items-center justify-center gap-5 px-6 py-10 text-center">{NAV_ITEMS.map(item => {
            const isActive = item.href === "/" ? pathname === "/" : pathname.startsWith(item.href);
            return <Link key={item.href} href={item.href} onClick={() => setOpen(false)} className={`text-2xl font-semibold leading-tight transition ${isActive ? "text-[var(--accent)]" : "text-[var(--text)] hover:text-[var(--accent)]"}`} style={{
              fontFamily: "var(--font-display), serif"
            }}>{item.label}</Link>;
          })}<Link href="/services" onClick={() => setOpen(false)} className={`text-2xl font-semibold leading-tight transition ${pathname.startsWith("/services") ? "text-[var(--accent)]" : "text-[var(--text)] hover:text-[var(--accent)]"}`} style={{
            fontFamily: "var(--font-display), serif"
          }}>Services</Link></nav><div className="border-t border-[var(--stroke)] px-6 pb-[max(2rem,env(safe-area-inset-bottom))] pt-5"><p className="text-center text-sm font-semibold text-[var(--text)]">Have a Project For Us?</p><Link href="/contact" onClick={() => setOpen(false)} className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[var(--accent)] to-[var(--accent-2)] px-6 py-3 text-sm font-semibold text-[#041018] shadow-[0_0_30px_-10px_var(--accent)]">Let's Connect <ArrowUpRight size={16} /></Link></div></div></div>;
    $[13] = open;
    $[14] = pathname;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}